<template>
   <div v-html="formatRichText(iptVal)" :style="{width:current.cptWidth + 'px',height:option.attribute.height + 'px'}"></div>
</template>

<script>
import {
  getDataJson,
  pollingRefresh,
  hasNonEmptyValues,
  hasProperty,
} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-textarea",
  props: {
    option: Object,
    refMap: Object,
    current:Object,
  },
  computed: {
    setStyles() {
      return {
        "--width": this.current.cptWidth + "px",
        "--height": this.option.attribute.height + "px",
      }
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  data() {
    return {
      uuid:null,
      iptVal: '',
      newData: "",
      jsFunFlag: false,
    }
  },
  watch: {
    'option.attribute': {
      handler(obj) {
         this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
      },
      deep: true
    },
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require("uuid").v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  methods: {
   refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () =>
        this.loadData(cptDataForm, paras)
      );
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.resStr
            : res; //相同数据集只调用一次接口原因
        that.jsFunFlag =
          cptDataForm.dataSource == "4" && hasProperty(res, "jsFunction")
            ? res.jsFunction
            : false; //相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag);
      });
    },
    processData(cptDataForm, res, jsFunFlag,isFromGrid) {
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == "4") {
        if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) {
              //判断此控件在九宫格里面就不请求数据
          // 没有全部配置映射字段
          console.log('333333344',res)
          if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
            let newres = [];
            let newObj = { ...res[0] };
            newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            newres.push(newObj);
            this.iptVal = newres[0].value;
          }
        // } else {
        //   // 如果配置了转换脚本
        //   this.iptVal = res.value;
        // }
      } else {
        // 不是数据集类型，是静态数据
        this.iptVal = this.newData.value;
        //this.iptVal = "<p><img src=\"/file/imgPool/202403/887ff9bc10f642739c1c0b3fd2d85941.png\" style=\"\" title=\"1711505334565090569.jpg\"/></p><p><img src=\"/file/imgPool/202403/887ff9bc10f642739c1c0b3fd2d85941.png\" style=\"\" title=\"1711505334657042547.jpg\"/></p><p><img src=\"/file/imgPool/202403/887ff9bc10f642739c1c0b3fd2d85941.png\" style=\"\" title=\"1711505339891091117.png\"/></p>"
      }
    },
    getValue() {
      return this.iptVal
    },
    setValue(value) {
      this.iptVal = value
    },
    formatRichText(html) { //图片自适应
    // if(!html)return
    if(!html) {
      return html
    }
    console.log(html,'asdasd')
    if(!html)return
     return html
    let newContent = html.replace(/<img[^>]*>/gi, function (match, capture) {
        match = match
          .replace(/style="[^"]+"/gi, "")
          .replace(/style='[^']+'/gi, "");
        match = match
          .replace(/width="[^"]+"/gi, "")
          .replace(/width='[^']+'/gi, "");
        match = match
          .replace(/height="[^"]+"/gi, "")
          .replace(/height='[^']+'/gi, "");
        return match;
      });
      newContent = newContent.replace(
        /style="[^"]+"/gi,
        function (match, capture) {
          match = match
            .replace(/width:[^;]+;/gi, "max-width:100%;")
            .replace(/width:[^;]+;/gi, "max-width:100%;");
          return match;
        }
      );
      newContent = newContent.replace(/<br[^>]*\/>/gi, "");
      newContent = newContent.replace(
        /\<img/gi,
        '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      );
      return newContent;
    },
  }
}
</script>

<style scoped>


</style>